import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Typography, Button } from '@mui/material';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Application error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
          bgcolor="#fcfcfd"
          px={3}
          textAlign="center"
        >
          <Typography variant="h4" sx={{ color: '#C9772B', mb: 2, fontWeight: 600 }}>
            Something went wrong
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4, maxWidth: 480 }}>
            An unexpected error occurred. Please try reloading the page. If the problem persists, contact support.
          </Typography>
          <Box display="flex" gap={2}>
            <Button
              variant="contained"
              onClick={this.handleReload}
              sx={{ bgcolor: '#C9772B', '&:hover': { bgcolor: '#6d3610' } }}
            >
              Reload Page
            </Button>
            <Button
              variant="outlined"
              onClick={this.handleGoHome}
              sx={{ borderColor: '#C9772B', color: '#C9772B' }}
            >
              Go to Dashboard
            </Button>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
